/**
 * Orders labels
 * Dynamic mapping from JSON based on current language
 */

import svOrders from '../locales/sv/orders.json';
import enOrders from '../locales/en/orders.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getOrdersLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enOrders : svOrders;
};

export const ordersLabels = (lang?: Language) => {
  return getOrdersLocale(lang);
};
